// extracted by mini-css-extract-plugin
export default {"aiLabel":"AIListItemLabel_aiLabel__0DK1y"};